import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  token: localStorage.getItem("token") || null,
  admin: localStorage.getItem("admin")
    ? JSON.parse(localStorage.getItem("admin"))
    : null,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    loginSuccess: (state, action) => {
      state.token = action.payload.token;
      state.admin = action.payload.admin;
      localStorage.setItem("token",   action.payload.token);
      localStorage.setItem("admin",   JSON.stringify(action.payload.admin));
      localStorage.setItem("role",    action.payload.admin.role);
      localStorage.setItem("adminId", action.payload.admin._id || action.payload.admin.roleId || "");
      localStorage.setItem("roleId",  action.payload.admin.roleId || "");
    },
    logout: (state) => {
      state.token = null;
      state.admin = null;
      localStorage.removeItem("token");
      localStorage.removeItem("admin");
      localStorage.removeItem("role");
      localStorage.removeItem("adminId");
      localStorage.removeItem("roleId");
    },
  },
});

export const { loginSuccess, logout } = authSlice.actions;
export default authSlice.reducer;